// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2POHU","overflowing":"ReadFullNote_overflowing__1q7UM"};